import gql from 'graphql-tag';

export const getMakes = gql`
  query makes {
    makes {
      id
      name
      bodyTypes {
        id
        name
      }
    }
  }
`;

export const getModels = gql`
  query models(
    $makeId: String!
    $bodyId: String!
    $yearLimits: String
    $newOnly: Boolean
  ) {
    models(
      makeId: $makeId
      bodyId: $bodyId
      yearLimits: $yearLimits
      newOnly: $newOnly
    ) {
      id
      name
      makeName
      transmissionGroups {
        id
        name
      }
      variants {
        id
        name
        modelYear
        external_code
        listPriceNet
        listPriceGst
        listPriceGross
        derivativeId
        derivative
        fuelTypeId
        fuelType
        engineSize
        engineCylinders
        engineDescription
        co2Emissions
        grossUnloadedWeight
        grossLoadedWeight
        grossTowedWeight
        fuelConsumption
        fuelConsumptionHighway
        fuelConsumptionCombined
        trimId
        trim
        transmissionId
        transmission
        transmissionGroupId
        doors
        seats
        serviceGroup
        length
        height
        fuelTankCapacity
        octaneRating
        warrantyMonths
        warrantyKms
        bodyTypeId
        photos {
          type
          path
        }
      }
    }
  }
`;
